import { css, styled } from 'twin.macro';
import { AdminTable } from '@/components/Admin/reusableStyles';
import { connect } from 'react-redux';
import Avatar from '@/components/Admin/reusableComponents/Avatar';
import { Fragment, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';

const TableHeader = styled.th`
    text-align: left;
`;

const TableRow = styled.tr`
    &:hover {
        background-color: #f9f9f9;
    }
`;

const TableCell = styled.td`
    padding: 15px 10px;
    border-bottom: 1px solid #eee;
    color: #5f6060;
`;
const TableSkeleton = () => (
    <Fragment>
        {[...Array(5)].map((_, i) => (
            <TableRow key={i}>
                {[...Array(5)].map((_, j) => (
                    <TableCell key={j}>
                        <Skeleton />
                    </TableCell>
                ))}
            </TableRow>
        ))}
    </Fragment>
);
const EmployeeVisitTable = ({ teamDashboardVisit = {}, currentPage, onPageChanged = () => {} }) => {
    const groupedVisitsArray = useMemo(() => {
        return Object.values(teamDashboardVisit?.groupedVisitsByEmployee || {});
    }, [teamDashboardVisit]);
    return (
        <Fragment>
            <AdminTable className="w-100 text-dark-grey">
                <thead>
                    <tr>
                        <TableHeader>SN</TableHeader>
                        <TableHeader>Employee</TableHeader>
                        {/* <TableHeader>Client</TableHeader> */}
                        <TableHeader>Forms Submitted</TableHeader>
                        <TableHeader>Visits Recorded</TableHeader>
                        {/* <TableHeader>Schedules</TableHeader> */}
                        {/* <TableHeader>Completed Schedules</TableHeader> */}
                        {/* <TableHeader style={{ textAlign: 'right' }}>Actions</TableHeader> */}
                    </tr>
                </thead>
                <tbody>
                    {teamDashboardVisit?.loading ? (
                        <TableSkeleton />
                    ) : (
                        <Fragment>
                            {(groupedVisitsArray || []).map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{index + 1}.</TableCell>
                                    <TableCell>
                                        <div
                                            css={css`
                                                display: flex;
                                                align-items: center;
                                            `}
                                        >
                                            <div>
                                                <Avatar item={item?.employee?.user} />
                                            </div>
                                            <div className="ml-2">{item?.employee?.user?.name}</div>
                                        </div>
                                    </TableCell>
                                    <TableCell>
                                        {(item.visits || []).reduce((sum, v) => sum + (v.forms?.length || 0), 0)}
                                    </TableCell>
                                    <TableCell>{(item.visits || []).length}</TableCell>
                                </TableRow>
                            ))}
                        </Fragment>
                    )}
                </tbody>
            </AdminTable>
            {!teamDashboardVisit?.loading && (
                <Fragment>
                    {teamDashboardVisit?.totalResults === 0 && (
                        <div className="m-4">
                            <div className="text-center mt-2">No Record Found</div>
                        </div>
                    )}
                </Fragment>
            )}
        </Fragment>
    );
};

const mapStateToProps = (state) => ({
    teamDashboardVisit: state.dashboard?.teamVisit || {},
    teams: state.teams.teams,
});

export default connect(mapStateToProps, {})(EmployeeVisitTable);
